/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface SettingsTherapistProfilePermissions { 
    add: boolean;
    change: boolean;
    destroy: boolean;
    view: boolean;
}
export const SettingsTherapistProfilePermissions_add_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SettingsTherapistProfilePermissions_change_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SettingsTherapistProfilePermissions_destroy_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SettingsTherapistProfilePermissions_view_Validators: ValidatorFn[] =
    [  Validators.required, ];


